import { appApi } from "../api";
import { AdminSettings } from "@/@types/app/AdminSettings";

export async function getAdminSettingsByIdentifier(identifier: string) {
	const { data } = await appApi.get<AdminSettings>("/AdminSettings", {
		identifier,
	});
	return data || ({} as AdminSettings);
}

export async function updateAdminSettings(identifier: string, enableNewCityNotification: boolean) {
	const response = await appApi.post("/AdminSettings/Update", {
		identifier,
		enableNewCityNotification,
	});
	return response.status === 200;
}
